import React from 'react';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';
import {Link} from "react-router-dom";
import Gmap from './gmap.component';
//import axios from 'axios';


export default function Home() {

    const loginState = useSelector(state => state.currentLogin);

    return(
        <div className="home-container">
            
            { loginState.isLoggedIn ? (
                <Gmap />
            )
            :   
            <>
                <div className="pic-jumbotron">  {/* <!--For Public if not logged in.  Main jumbotron for a primary marketing message or call to action, refer to index.css {.pic-jumbotron} for image link  --> */}
                    <div className="container">
                        <div className="pic-jumbotron-text">
                            <h3 className="display-4 text-shadow-jumbotron">Ready for your Telemetry Transformation?</h3>
                            <h4 className="text-shadow-jumbotron" >Register to Start Now!</h4>
                            <Link to={`/contact`} className="nav-link">
                                <Button variant="primary">Submit Enquiry</Button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="container" style={{ marginTop: 20 }}>
                    <div>Login to see sites readings.</div>
                    {/*<button onClick={addItemRedux}> Add Item Redux...</button>
                    <button onClick={getDataLoggerFieldList}> getDataLoggerFieldList </button>*/}
                    
                    {/*
                    <div>
                        {
                            graphFields.map(item => <li key={item.id}>{item.name} ~ {item.isChecked}</li>)
                        }
                    </div>
                    */}
                </div>
            </>
            }
        </div>
    );
}
